import React from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { postDel } from "../../redux/actionCreators/postsActionCreator";
import "./postCard.css"
import { useEffect } from "react";

const PostCard = ({ post, id }) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const postDelete = () => {
    dispatch(postDel(post.postId));
  };

//   useEffect(() => {
    
//     history.push("/admin/dashboard/posts");
  
// }, [dispatch]);

  let currentDate = new Date();
  let endDate = new Date(`${post.post.endDate} ${post.post.endTime}`);
  let disable = false;
  if(endDate < currentDate)
  {
    disable = true;
    console.log(disable);
  }
  return (
    <div className="card col-md-3 px-0 m-2" style={{height: "460px"}} key={id}>
      {/* <table>
        <thead>
          <tr>  
            <th>Post Text</th>
            <th>Location</th>
            <th>Position</th>
            <th>Image</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>adsd asdsa</td>
            <td>Lahore</td>
            <td>4</td>
            <td>sdsd sdsfd</td>
          </tr>
        </tbody>
      </table> */}
      <img
        className="card-img-top" width={"40px"} height={"240px"}
        src={post.post.postMedia[0].url}
        alt={post.post.postText}
      />
      <div className="card-body pl-4 text-justify">
        <h5 className="card-title">{post.post.postText.toUpperCase()}</h5>
        <p className="card-text mb-0">
          {post.post.description}
        </p>
        <div className="text-left">
              {disable ? (
                  <li className="text-danger"> Ad Expired</li>
                ) : (
                  <div></div>
                )
              }
        </div>
      </div>
      <div className="card-footer p-3 bg-white" style={{height: "80px"}}>
        {/* <div className="d-flex align-items-center my-2 justify-content-between">
          <p>
            <i className="fa fa-thumbs-up"></i> Likes {post.post.likes}
          </p>
          <p className="bg-dark text-white py-1 px-2">{post.post.postedBy}</p>
        </div> */}
        <div className="">
          {/* <button
            className="btn btn-primary  my-2 btn-block"
            onClick={() => history.push(`/admin/dashboard/post/${post.postId}`)}
          >
            <i className="fa fa-eye"></i> See Ad
          </button> */}
          <div className="text-right">
            <button
              type="button"
              onClick={() =>
                history.push(`/admin/dashboard/post/${post.postId}/edit`)
              }
              className="btn  my-2  mx-1" style={{backgroundColor: "#1AC5D9", borderRadius: "100px", color: "white"}}
            >
              <i className="fa fa-pencil"></i> Edit
            </button>
            <button
              type="button"
              onClick={postDelete}
              className="btn btn-danger my-2ss" style={{borderRadius: "100px", color: "white"}}
            >
              <i className="fa fa-trash-o"></i> Delete
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PostCard;
